import React from "react"
import { useSelector } from "react-redux";
import { Formik } from "formik";

import { validationSchema } from "../formSettings";
import { downloadFile } from "./downloadFile";
import { useCreateInitialValue } from "../hooks/useCreateInitialValue";
import { useSubmitCallback } from "../hooks/useSubmitCallback";

import { FormComponent } from "./FormComponent";

import { getUser } from "../../../../store/modules/session/selectors";

export const FileSystem: React.FC = () => {
  const user = useSelector(getUser);

  const initialValues = useCreateInitialValue(user);
  const onSubmit = useSubmitCallback(user, downloadFile);

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={onSubmit}
      component={FormComponent}
      validationSchema={validationSchema}
      enableReinitialize
    />
  );
};
